export const SOCIAL_MEDIA = {
  linkedin: 'https://www.linkedin.com/company/innosearch-ai/',
  facebook: 'https://www.facebook.com/innosearchai',
  instagram: 'https://www.instagram.com/innosearchai/',
  x: 'https://twitter.com/innosearchai',
}

export const EMAIL = 'info@innosearch.ai'

export const ADDRESS = '530 Showers Dr, Suite 236, Mountain View, CA 94040'

export const TERMS_OF_USE = 'https://blog.innosearch.ai/terms-of-use'
export const PRIVACY_POLICY = 'https://blog.innosearch.ai/privacy-policy'
export const SHIPPING_AND_RETURN_POLICY =
  'https://blog.innosearch.ai/innosearchs-shipping-and-return-policies'
